import { KioskResource } from './KioskResource';

export class SliderFilesAndKioskResource {
    rid: number;
    kiosk: KioskResource;
}